<div class="progress" [ngClass]="design">
    <div class="progress__bar" [ngStyle]="{'width.%': value}"></div>
</div>